<template>
  <div class="dash">
    <!-- Hesap -->
    <div class="dash-account">
      <div class="dash-account-label">Hesap</div>
      <div v-if="accounts" class="dash-select">
        <span class="material-symbols-outlined dash-select-icon">domain</span>
        <select
          name="accounts"
          id="accounts"
          v-model="currentAccountId"
          @change="accountChange($event.target.value)"
        >
          <option v-for="a in accounts" :value="a.Id" :key="a.Id">
            {{ a.Title }} ({{ a.WaitingJobCount }})
          </option>
        </select>
        <span class="material-symbols-outlined dash-select-arrow">expand_more</span>
      </div>
      <div v-else class="dash-account-title">
        <span class="material-symbols-outlined dash-select-icon">domain</span>
        <span>{{ currentAccount.Title }}</span>
      </div>
    </div>

    <h1 class="dash-title">İşlerim</h1>

    <div class="dash-grid" v-if="myStats">
      <button type="button" class="dash-card dash-card-main" @click="goToJobPage('MyWaiting')">
        <span class="dash-card-icon"><span class="material-symbols-outlined">pending_actions</span></span>
        <span class="dash-card-body">
          <span class="dash-card-count">{{ myStats.Waiting }}</span>
          <span class="dash-card-text">{{ getJobTypeText("MyWaiting") }}</span>
        </span>
        <span class="material-symbols-outlined dash-card-arrow">chevron_right</span>
      </button>

      <button type="button" class="dash-card dash-card-success" @click="goToJobPage('MyApproved')">
        <span class="dash-card-icon"><span class="material-symbols-outlined">task_alt</span></span>
        <span class="dash-card-count">{{ myStats.Approved }}</span>
        <span class="dash-card-text">{{ getJobTypeText("MyApproved") }}</span>
      </button>

      <button type="button" class="dash-card dash-card-rem" v-if="hasAuth('Rem')" @click="goToJobPage('Rem')">
        <span class="dash-card-icon"><span class="material-symbols-outlined">mail</span></span>
        <span class="dash-card-count">{{ myStats.Rem }}</span>
        <span class="dash-card-text">{{ getJobTypeText("Rem") }}</span>
      </button>

      <button type="button" class="dash-card dash-card-danger" @click="goToJobPage('MyDeclined')">
        <span class="dash-card-icon"><span class="material-symbols-outlined">cancel</span></span>
        <span class="dash-card-count">{{ myStats.Declined }}</span>
        <span class="dash-card-text">{{ getJobTypeText("MyDeclined") }}</span>
      </button>

      <button type="button" class="dash-card dash-card-warning" @click="goToJobPage('MyCanceled')">
        <span class="dash-card-icon"><span class="material-symbols-outlined">block</span></span>
        <span class="dash-card-count">{{ myStats.Canceled }}</span>
        <span class="dash-card-text">{{ getJobTypeText("MyCanceled") }}</span>
      </button>
    </div>
    <div v-else-if="myStatsError" class="dash-error">
      <span class="material-symbols-outlined">error</span>
      {{ myStatsError }}
    </div>
    <div v-else class="dash-loading">Yükleniyor...</div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  computed: {
    user() {
      return this.$store.state.user;
    },
    currentAccount() {
      return this.$root.$data.login.Account;
    },
  },
  data() {
    return {
      myStats: null,
      myStatsError: null,
      accounts: null,
      currentAccountId: this.$root.$data.login.Account.Id,
    };
  },
  methods: {
    goToJobPage(pageName) {
      this.$router.push({ name: "Job", hash: "#" + pageName });
    },
    getMyStats() {
      this.myStats = null;
      this.myStatsError = null;

      axios
        .get("/dashboard/myjobs")
        .then((r) => {
          this.myStats = r.data;
        })
        .catch((r) => {
          console.log("MyStatsErr:", r);
          this.myStatsError = "Yüklenemedi.";

          if (r.response && r.response.data.ModelState?.InvalidTokenException) {
            window.processErrorResponse(r, this);
          }
        });
    },

    getAccounts() {
      axios.get("/userAccounts/get").then((x) => {
        if (x.data.Success) {
          this.accounts = x.data.Data;
          //this.currentAccountId = this.$root.$data.login.Account.Id;
        }
      });
    },
    accountChange(accountId) {
      var account = this.accounts.filter((x) => x.Id == accountId)[0];

      console.log("account change:", account, this.currentAccount);

      if (account.Code == this.currentAccount.Code) return;

      //if (!confirm(`${account.Title} hesabına geçiş yapılacak.`)) return;
      this.$izonayConfirm(
        `'${account.Title}' hesabına geçiş yapmak istediğinize emin misiniz?`
      ).then((response) => {
        if (!response.isConfirmed) {
          this.currentAccountId = this.currentAccount.Id;
          return;
        }

        axios
          .post(`/switchaccount/post/${account.Id}`)
          .then((x) => {
            this.errorMessage = null;
            console.log("Gelen sonuç:", x);
            if (x.data.Success) {
              window.localStorage.setItem("user", JSON.stringify(x.data.Data));
              axios.defaults.headers.common["token"] = x.data.Data.Key;
              this.$root.$data.login = x.data.Data;
              this.registerDeviceToken();
              //this.currentAccountId = this.$root.$data.login.Account.Id;
              //this.$router.push("/" + x.data.Data.Account.Code);
              // this.$router.push({ path: "/" + x.data.Data.Account.Code });
              // this.$router.go();
              location.reload()
            } else {
              this.$izonayAlert(x.ErrorMessages);
              this.loading = false;
            }
            console.log(
              "Token geldi: ",
              axios.defaults.headers.common["token"]
            );
          })
          .catch((e) => {
            window.processErrorResponse(e, this);
            this.loading = false;
          });
      });
    },
  },
  created() {
    //this.currentAccount = this.$root.$data.login.Account;
    this.getMyStats();
    this.getAccounts();
    console.log("createed currentAccount: ", this.currentAccount);
    this.currentAccountId = this.$root.$data.login.Account.Id;
  },
};
</script>
<style scoped>
.dash {
  box-sizing: border-box;
  max-width: 560px;
  margin: 0 auto;
  padding: 8px 4px 24px 4px;
  font-family: 'Poppins', Avenir, Helvetica, Arial, sans-serif;
  color: #092154;
}

/* Hesap */
.dash-account {
  margin-bottom: 20px;
}

.dash-account-label {
  margin-bottom: 6px;
  font-weight: 500;
  font-size: 13px;
  color: #808080;
}

.dash-select,
.dash-account-title {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  box-sizing: border-box;
  height: 50px;
  padding: 0 12px;
  border: 1px solid #E6E9EE;
  border-radius: 8px;
  background-color: #ffffff;
}

.dash-account-title {
  font-weight: 600;
  font-size: 15px;
}

.dash-select-icon {
  flex-shrink: 0;
  font-size: 20px;
  color: #808080;
}

.dash-select select {
  appearance: none;
  -webkit-appearance: none;
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  padding: 0 28px 0 0;
  border: none;
  outline: none;
  background: transparent;
  font-weight: 600;
  font-size: 15px;
  color: #092154;
}

.dash-select-arrow {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 22px;
  color: #808080;
  pointer-events: none;
}

.dash-select:focus-within {
  border-color: #097DFF;
}

/* Başlık */
.dash-title {
  margin: 0 0 14px 0;
  font-weight: 600;
  font-size: 20px;
  line-height: 140%;
  color: #092154;
}

/* Kartlar */
.dash-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.dash-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  box-sizing: border-box;
  min-height: 120px;
  padding: 16px;
  border: 1px solid #EFEFEF;
  border-radius: 16px;
  background-color: #ffffff;
  box-shadow: 0 2px 12px rgba(9, 33, 84, 0.06);
  text-align: left;
  color: #092154;
  cursor: pointer;
}

.dash-card:active {
  transform: scale(0.98);
}

.dash-card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin-bottom: 6px;
  border-radius: 10px;
  font-size: 22px;
}

.dash-card-count {
  font-weight: 600;
  font-size: 28px;
  line-height: 120%;
}

.dash-card-text {
  font-weight: 400;
  font-size: 13px;
  line-height: 140%;
  color: #808080;
}

/* Bekleyen işler: tam genişlik, lacivert */
.dash-card-main {
  grid-column: 1 / -1;
  flex-direction: row;
  align-items: center;
  gap: 14px;
  min-height: 0;
  padding: 18px 16px;
  border-color: #092154;
  background-color: #092154;
  color: #ffffff;
}

.dash-card-main .dash-card-icon {
  margin-bottom: 0;
  background-color: rgba(255, 255, 255, 0.14);
  color: #ffffff;
}

.dash-card-main .dash-card-body {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
}

.dash-card-main .dash-card-count {
  font-size: 32px;
}

.dash-card-main .dash-card-text {
  color: rgba(255, 255, 255, 0.75);
}

.dash-card-arrow {
  flex-shrink: 0;
  font-size: 24px;
  color: rgba(255, 255, 255, 0.75);
}

.dash-card-success .dash-card-icon { background-color: #E4F6EA; color: #1E9E57; }
.dash-card-success .dash-card-count { color: #1E9E57; }

.dash-card-rem .dash-card-icon { background-color: #E9F4FF; color: #097DFF; }

.dash-card-danger .dash-card-icon { background-color: #FDE8EA; color: #FF3B30; }
.dash-card-danger .dash-card-count { color: #FF3B30; }

.dash-card-warning .dash-card-icon { background-color: #FFF1E3; color: #F37615; }
.dash-card-warning .dash-card-count { color: #F37615; }

/* Durumlar */
.dash-loading {
  padding: 32px 0;
  text-align: center;
  font-size: 13px;
  color: #808080;
}

.dash-error {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid #F4C7C3;
  border-radius: 8px;
  background-color: #FDE8EA;
  font-size: 13px;
  color: #C62C3A;
}
</style>
